import {useForm, Controller, useWatch} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	SelectServiceAll
} from "~/components/Forms";
import {useEffect} from "react";

function HostInfoFormEdit({item, onHandleSubmit})
{
	const initialValues = {
		domain: '',
		hostIp: '',
		hostName: '',
		serviceId: 0,
	}

	const validationSchema = Yup.object().shape({
		domain: Yup.string().required('Bạn chưa nhập tên miền'),
		hostIp: Yup.string().required('Bạn chưa nhập ip host'),
		hostName: Yup.string().required('Bạn chưa nhập tên host'),
		serviceId: Yup.number().required('Bạn chưa nhập id dịch vụ')
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset, setValue} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		if (item?.id) {
			initialValues.domain = item.domain;
			initialValues.hostIp = item.hostIp;
			initialValues.hostName = item.hostName;
			initialValues.serviceId = item.serviceId;
			initialValues.companyWard = item.companyWard;
		}
		reset(initialValues);
	}, [item?.id]);

	const onSubmit = async (data) =>
	{
		await onHandleSubmit(item, data);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Yêu cầu</p>
			<Controller control={control} name="domain" render={({field}) => (
				<InputField label="Tên miền" errors={errors} {...field} />
			)}/>
			<Controller control={control} name="hostIp" render={({field}) => (
				<InputField label="Ip host" errors={errors} {...field} />
			)}/>
			<Controller control={control} name="hostName" render={({field}) => (
				<InputField label="Tên host" errors={errors} {...field} />
			)}/>
			<Controller control={control} name="serviceId" render={({ field }) => (
				<SelectServiceAll service={"host"} label="Dịch vụ Host" placeholder={'Điền tên miền hiện tại của dịch vụ host'} options={[]} errors={errors} {...field} />
			)}/>
			<hr/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Cập nhật yêu cầu</Button>
			</div>
		</form>
	)
}

export default HostInfoFormEdit;